// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-section[data-v-d108f992]{margin-bottom:25px}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Contracts/ContractCsvFiles/Upload.vue"],"names":[],"mappings":"AACI,+BACI,kBAAA","sourcesContent":["\n    .file-section {\n        margin-bottom: 25px;\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
